import React from "react";
import { Results } from "@app/scripts/reactify/results/Results";

export const Collection = (ReactifySearchData) => {
  return <Results ReactifySearchData={ReactifySearchData} />;
};
